/* eslint-disable react/jsx-props-no-spreading */

/* eslint-disable jsx-a11y/control-has-associated-label */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import * as AppPropTypes from '../../lib/PropTypes';

import FilmTrailer from '../partials/FilmTrailer';

import styles from '../../../styles/modals/film-modal.module.scss';

const propTypes = {
    item: AppPropTypes.page.isRequired,
    onClose: PropTypes.func.isRequired,
    visible: PropTypes.bool.isRequired,
    trailerOnly: PropTypes.bool,
    className: PropTypes.string,
};

const defaultProps = {
    trailerOnly: false,
    className: null,
};

const FilmModal = ({ item, className, onClose, trailerOnly, visible }) => (
    <div
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
                [styles.visible]: visible,
                [styles.trailerOnly]: trailerOnly,
            },
        ])}
    >
        <div className={styles.inner}>
            <FilmTrailer
                item={item}
                onClose={onClose}
                visible={visible}
                trailerOnly={trailerOnly}
            />
        </div>
    </div>
);

FilmModal.propTypes = propTypes;
FilmModal.defaultProps = defaultProps;

export default FilmModal;
